import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const propertyAPI = {
  // Get all properties with filters and pagination
  getProperties: async (filters = {}, page = 1, limit = 12) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });

    const response = await api.get(`/properties?${params.toString()}`);
    return response.data;
  },

  // Search properties with text query
  searchProperties: async (query, filters = {}, page = 1, limit = 12) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    if (query) params.append('q', query);
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });

    const response = await api.get(`/properties/search?${params.toString()}`);
    return response.data;
  },

  // Get single property by ID
  getPropertyById: async (propertyId) => {
    const response = await api.post('/properties/get-property', { propertyId });
    return response.data;
  },

  // Create new property
  createProperty: async (formData) => {
    const response = await api.post('/properties', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update property
  updateProperty: async (propertyId, formData) => {
    // Add propertyId to formData
    formData.append('propertyId', propertyId);
    
    const response = await api.put('/properties', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete property
  deleteProperty: async (propertyId) => {
    const response = await api.delete('/properties', {
      data: { propertyId }
    });
    return response.data;
  },

  // Get user's properties
  getMyProperties: async (page = 1, limit = 12) => {
    const response = await api.get(`/properties/owner/my-properties?page=${page}&limit=${limit}`);
    return response.data;
  },

  // Delete specific image
  deletePropertyImage: async (propertyId, imageKey) => {
    try {
      // URL encode the imageKey to handle slashes in the key
      const encodedKey = encodeURIComponent(imageKey);
      console.log('📡 Original key:', imageKey);
      console.log('📡 Encoded key:', encodedKey);
      console.log('📡 API Call: DELETE /properties/' + propertyId + '/images/' + encodedKey);
      
      const response = await api.delete(`/properties/${propertyId}/images/${encodedKey}`);
      console.log('📡 API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('📡 API Error:', error.response?.data || error.message);
      throw error;
    }
  },

  // Delete property video
  deletePropertyVideo: async (propertyId) => {
    try {
      console.log('📡 API Call: DELETE /properties/' + propertyId + '/video');
      const response = await api.delete(`/properties/${propertyId}/video`);
      console.log('📡 API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('📡 API Error:', error.response?.data || error.message);
      throw error;
    }
  },
};

export default propertyAPI;

